import Main from "@/components/main";

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项 ，在main中直接splice移除掉这个路由
 *  sideMenuItemHidden: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  // 登录页
  {
    path: "/login",
    name: "login",
    meta: {
      title: "Login - 登录",
      hideInMenu: true,
      nameText: "router.index.login"
    },
    component: () => import("@/view/login/login.vue")
  },
  // 首页
  {
    path: "/",
    name: "_home",
    redirect: "/home",
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true,
      nameText: "router.index.home"
    },
    children: [
      {
        path: "/home",
        name: "home",
        meta: {
          hideInMenu: true,
          title: "首页",
          notCache: true,
          icon: "md-home",
          nameText: "router.index.home"
        },
        component: () => import("@/view/home/homePage.vue")
      }
    ]
  },
  // 平台运营数据
  {
    path: "/operationalData",
    name: "operationalData",
    component: Main,
    meta: {
      title: "运营数据管理",
      nameText: "router.index.operationalData",
      id: 2939
    },
    redirect: "/operationalData/list",
    children: [
      {
        path: "list",
        name: "operational",
        meta: {
          title: "全区运营数据",
          nameText: "router.index.operateList",
          id: 2940
        },
        component: () => import("@/view/operationalData/index.vue")
      },
      {
        path: "arIndex",
        name: "arList",
        meta: {
          title: "阿语区运营数据",
          nameText: "router.index.arList",
          id: 2941
        },
        component: () => import("@/view/operationalData/arIndex.vue")
      },
      {
        path: "noArIndex",
        name: "noArList",
        meta: {
          title: "英语区运营数据",
          nameText: "router.index.noArList",
          id: 2942
        },
        component: () => import("@/view/operationalData/noArIndex.vue")
      },
      {
        path: "trArIndex",
        name: "trArList",
        meta: {
          title: "非阿语区运营数据",
          nameText: "router.index.trArList",
          id: 2942
        },
        component: () => import("@/view/operationalData/trArIndex.vue")
      }
    ]
  },
  // 用户信息管理
  {
    path: "/user",
    name: "user",
    component: Main,
    meta: {
      title: "用户信息管理",
      nameText: "router.index.userInfomation",
      id: 1
    },
    redirect: "/user/userInformation",
    children: [
      {
        path: "userInformation",
        name: "userInformation",
        component: () => import("@/view/userInformation/index.vue"),
        meta: {
          title: "用户信息管理",
          nameText: "router.index.userInfomation",
          hideInBread: true, // 模块的首页
          id: 1
        }
      },
      {
        path: "connectionLog",
        name: "connectionLog",
        component: () => import("@/view/userInformation/connectionLog.vue"),
        meta: {
          title: "连接日志",
          nameText: "router.index.connectionLog",
          sideMenuItemHidden: true,
          id: 1
        }
      },
      {
        path: "topUpLog",
        name: "topUpLog",
        component: () => import("@/view/userInformation/topUpLog.vue"),
        meta: {
          title: "充值记录",
          nameText: "router.index.topUpLog",
          sideMenuItemHidden: true,
          id: 1
        }
      },
      {
        path: "ipLog",
        name: "ipLog",
        component: () => import("@/view/userInformation/ipLog.vue"),
        meta: {
          title: "ip记录",
          nameText: "router.index.ipLog",
          sideMenuItemHidden: true,
          id: 1
        }
      },
      {
        path: "facilityLog",
        name: "facilityLog",
        component: () => import("@/view/userInformation/facilityLog.vue"),
        meta: {
          title: "同设备账号记录",
          nameText: "router.index.facilityLog",
          sideMenuItemHidden: true,
          id: 1
        }
      },
      {
        path: "statement",
        name: "statement",
        component: () => import("@/view/userInformation/statement.vue"),
        meta: {
          title: "消费明细",
          nameText: "router.index.statement",
          sideMenuItemHidden: true,
          id: 1
        }
      },
      {
        path: "expensesRecord",
        name: "expensesRecord",
        component: () => import("@/view/userInformation/expensesRecord.vue"),
        meta: {
          title: "消费记录",
          nameText: "router.index.expensesRecord",
          sideMenuItemHidden: true,
          id: 1
        }
      },
      {
        path: "photoAlbum",
        name: "photoAlbum",
        component: () => import("@/view/userInformation/photoAlbum.vue"),
        meta: {
          title: "消费记录",
          nameText: "router.index.photoAlbum",
          sideMenuItemHidden: true,
          id: 1
        }
      },
      {
        path: "detail/:code", // 页面中有使用这个路由的地方，不可随便修改路由
        name: "detail",
        component: () => import("@/view/userInformation/detail.vue"),
        meta: {
          title: "用户详情",
          nameText: "router.index.userDetail",
          sideMenuItemHidden: true,
          id: 1
        }
      },
      {
        path: "diamondIncome",
        name: "diamondIncome",
        component: () => import("@/view/userInformation/diamondIncome.vue"),
        meta: {
          title: "消费记录",
          nameText: "router.index.diamondRecord",
          sideMenuItemHidden: true,
          id: 1
        }
      }
    ]
  },
  // 充值用户管理
  {
    path: "/rechargeUserManagement",
    name: "rechargeUserManagement",
    component: Main,
    meta: {
      title: "充值用户管理",
      nameText: "router.index.diamondRecharge",
      id: 2656
    },
    redirect: "/rechargeUserManagement/yellowRecharge",
    children: [
      {
        path: "yellowRecharge",
        name: "recharge-yellowRecharge",
        component: () =>
          import("@/view/rechargeUserManagement/yellowRecharge.vue"),
        meta: {
          title: "黄钻充值",
          nameText: "router.index.yellowRecharge",
          id: 2657
        }
      },
      {
        path: "pinkRecharge",
        name: "rechargeUserManagement-pinkRecharge",
        component: () =>
          import("@/view/rechargeUserManagement/pinkRecharge.vue"),
        meta: {
          title: "粉钻充值",
          nameText: "router.index.pinkRecharge",
          id: 2658
        }
      },
      {
        path: "whiteRoll",
        name: "rechargeUserManagement-whiteRoll",
        component: () => import("@/view/rechargeUserManagement/whiteRoll.vue"),
        meta: {
          title: "checkout白名单",
          nameText: "router.index.whiteRoll",
          id: 3499
        }
      }
    ]
  },
  // 视频聊天
  {
    path: "/video-chat_statistics",
    name: "video-chat_statistics",
    component: Main,
    meta: {
      title: "视频聊天",
      nameText: "router.index.videoChatStatistics",
      id: 2662
    },
    redirect: "/videoChatStatistics/list",
    children: [
      {
        path: "list",
        name: "videoChatStatistics",
        meta: {
          title: "数据统计",
          nameText: "router.index.dataStatistics",
          hideInBread: true,
          id: 2462
        },
        component: () => import("@/view/videoChatStatistics/index.vue")
      },
      // 数据统计 end------------------------------
      {
        path: "guildUsers",
        name: "guildUsers",
        meta: {
          title: "主播管理",
          nameText: "router.index.guildUsers",
          hideInBread: true,
          id: 281
        },
        component: () => import("@/view/guildUsers/index.vue")
      },
      {
        path: "/guildUsers/connectionLog",
        name: "guildConnect",
        meta: {
          title: "连接日志",
          nameText: "router.index.guildConnect",
          sideMenuItemHidden: true,
          id: 281
        },
        component: () => import("@/view/guildUsers/connectionLog.vue")
      },
      {
        path: "/guildUsers/goldLog",
        name: "goldLog",
        meta: {
          title: "金币扣除记录",
          nameText: "router.index.goldLog",
          sideMenuItemHidden: true,
          id: 281
        },
        component: () => import("@/view/guildUsers/goldLog.vue")
      },
      {
        path: "/guildUsers/deductLog",
        name: "deductLog",
        meta: {
          title: "豆子扣除记录",
          nameText: "router.index.deductLog",
          sideMenuItemHidden: true,
          id: 281
        },
        component: () => import("@/view/guildUsers/deductLog.vue")
      },
      // 主播管理 end------------------------------
      {
        path: "agentList",
        name: "agentList",
        meta: {
          title: "公会管理",
          nameText: "router.index.agentList",
          hideInBread: true,
          id: 591
        },
        component: () => import("@/view/agentList/index.vue")
      },
      // 公会管理 end------------------------------
      {
        path: "onlineStatistics",
        name: "onlineStatistics",
        meta: {
          title: "在线统计",
          nameText: "router.index.onlineStatistics",
          hideInBread: true,
          id: 1551
        },
        component: () => import("@/view/onlineStatistics/index.vue")
      },
      // 在线统计 end------------------------------
      {
        path: "matchLog",
        name: "matchLog",
        meta: {
          title: "匹配日志",
          nameText: "router.index.matchLog",
          hideInBread: true,
          id: 431
        },
        component: () => import("@/view/matchLog/matchLog.vue")
      },
      {
        path: "/matchLog/matchLogSDetail",
        name: "matchLogSDetail",
        meta: {
          title: "批次对详情页",
          nameText: "router.index.matchLog2",
          sideMenuItemHidden: true,
          id: 431
        },
        component: () => import("@/view/matchLog/matchLogSDetail.vue")
      },
      {
        path: "/matchLog/matchLogSTotalDetail",
        name: "matchLogSTotalDetail",
        meta: {
          title: "优先级总分详情页",
          nameText: "router.index.matchLog3",
          sideMenuItemHidden: true,
          id: 431
        },
        component: () => import("@/view/matchLog/matchLogSTotalDetail.vue")
      },
      {
        path: "/matchLog/matchLogRelation",
        name: "matchLogRelation",
        meta: {
          title: "关系总分详情",
          nameText: "router.index.matchLog4",
          sideMenuItemHidden: true,
          id: 431
        },
        component: () => import("@/view/matchLog/matchLogRelation.vue")
      },
      {
        path: "/matchLog/matchLogExcellent",
        name: "matchLogExcellent",
        meta: {
          title: "质量总分详情页",
          nameText: "router.index.matchLog5",
          sideMenuItemHidden: true,
          id: 431
        },
        component: () => import("@/view/matchLog/matchLogExcellent.vue")
      },
      {
        path: "/matchLog/matchLogRelationTop",
        name: "matchLogRelationTop",
        meta: {
          title: "匹配总分详情页",
          nameText: "router.index.matchLog6",
          sideMenuItemHidden: true,
          id: 431
        },
        component: () => import("@/view/matchLog/matchLogRelationTop.vue")
      },
      {
        path: "/matchLog/matchLogOrder",
        name: "matchLogOrder",
        meta: {
          title: "落单用户",
          nameText: "router.index.matchLog7",
          sideMenuItemHidden: true,
          id: 431
        },
        component: () => import("@/view/matchLog/matchLogOrder.vue")
      }
      // 匹配日志 end------------------------------
    ]
  },
  // 群组管理
  {
    path: "/group-management",
    name: "group-management",
    component: Main,
    meta: {
      title: "群组管理",
      nameText: "router.index.groupManagement",
      id: 161
    },
    redirect: "/group-management/list",
    children: [
      {
        path: "list",
        name: "groupManagement",
        meta: {
          title: "群组管理列表",
          nameText: "router.index.groupManagement",
          id: 161
        },
        component: () => import("@/view/groupManagement/index.vue")
      },
      {
        // 这里的路由修改，对应的detail页面有个跳转操作也要修改
        path: "detail/:code", // 这里的路由修改，对应的detail页面有个跳转操作也要修改
        name: "groupManagementDetail",
        meta: {
          title: "群组管理详情",
          nameText: "router.index.groupManagementDetail",
          sideMenuItemHidden: true,
          id: 161
        },
        component: () => import("@/view/groupManagement/detail.vue")
      }
    ]
  },
  // 房间管理
  {
    path: "/roomManagement",
    name: "room-management",
    component: Main,
    meta: {
      title: "房间管理",
      nameText: "router.index.allActivityRoom",
      id: 3442
    },
    redirect: "/roomManagement/list",
    children: [
      {
        path: "list",
        name: "roomActivity",
        meta: {
          title: "常规房间充值活动",
          nameText: "router.index.roomManagement",
          id: 3443
        },
        component: () => import("@/view/roomManagement/index.vue")
      },
      {
        path: "specialRoom",
        name: "specialActivity",
        meta: {
          title: "特殊房间充值活动",
          nameText: "router.index.specialRoom",
          id: 3510
        },
        component: () => import("@/view/specialRoom/index.vue")
      },
      {
        path: "taskIndex/:code",
        name: "taskIndex",
        meta: {
          title: "任务配置",
          nameText: "views.roomActivity.list3_title11",
          hideInBread: true,
          sideMenuItemHidden: true,
          id: 3511
        },
        component: () => import("@/view/specialRoom/taskIndex.vue")
      }
    ]
  },

  // 推广员管理
  {
    path: "/expandManagement",
    name: "expandManagement",
    component: Main,
    meta: {
      title: "推广员管理",
      nameText: "router.index.expandManagement",
      id: 2663
    },
    redirect: "/expandManagement/page",
    children: [
      {
        path: "page",
        name: "expandManagement-page",
        component: () => import("@/view/expandManagement/index.vue"),
        meta: {
          title: "推广员管理",
          nameText: "router.index.expandManagement",
          id: 2663
        }
      }
    ]
  },
  // 真人认证审核
  {
    path: "/certificationAudit",
    name: "certificationAudit",
    component: Main,
    meta: {
      title: "真人认证审核",
      nameText: "router.index.certificationAudit",
      id: 3503
    },
    redirect: "/certificationAudit/page",
    children: [
      {
        path: "page",
        name: "certificationAudit-page",
        component: () => import("@/view/certificationAudit/index.vue"),
        meta: {
          title: "真人认证审核",
          nameText: "router.index.certificationAudit",
          id: 2663
        }
      }
    ]
  },
  // 礼物管理
  {
    path: "/giftManagement",
    name: "giftManagement",
    component: Main,
    meta: {
      title: "礼物管理模块",
      nameText: "router.index.giftManage",
      id: 341
    },
    redirect: "/giftManagement/list",
    children: [
      {
        path: "list",
        name: "giftList",
        component: () => import("@/view/giftManagement/index.vue"),
        meta: {
          title: "礼物管理列表",
          nameText: "router.index.giftManage",
          id: 341
        }
      }
    ]
  },
  // 管理员操作记录（administrator_operation_record）
  {
    path: "/administrator",
    name: "administrator",
    component: Main,
    meta: {
      title: "管理员操作记录",
      nameText: "router.index.administratorOperationRecord",
      id: 2861
    },
    redirect: "/administrator/list",
    children: [
      {
        path: "list",
        name: "list",
        component: () => import("@/view/administrator/index.vue"),
        meta: {
          title: "管理员操作记录",
          nameText: "router.index.administratorOperationRecord",
          id: 2861
        }
      }
    ]
  },
  // 举报处理
  {
    path: "/report",
    name: "report",
    component: Main,
    meta: {
      title: "举报处理",
      nameText: "router.index.report",
      id: 391
    },
    redirect: "/report/list",
    children: [
      {
        path: "list",
        name: "reportList",
        component: () => import("@/view/report/index.vue"),
        meta: {
          title: "举报处理列表",
          nameText: "router.index.reportList",
          hideInBread: true,
          id: 391
        }
      }
    ]
  },
  // 推荐用户管理
  {
    path: "/referrerUser",
    name: "referrer_user",
    component: Main,
    meta: {
      title: "推荐用户管理",
      nameText: "router.index.referrerUser",
      id: 491
    },
    redirect: "/referrerUser/list",
    children: [
      {
        path: "list",
        name: "referrer",
        component: () => import("@/view/referrerUser/index.vue"),
        meta: {
          title: "推荐用户管理",
          nameText: "router.index.referrerUser",
          hideInBread: true,
          id: 491
        }
      }
    ]
  },
  // 管理设置
  {
    path: "/managementSettings",
    name: "management",
    component: Main,
    meta: {
      title: "管理设置模块",
      nameText: "router.index.management",
      id: 521
    },
    redirect: "/managementSettings/list",
    children: [
      {
        path: "list",
        name: "adminList",
        meta: {
          title: "管理设置模块列表",
          nameText: "router.index.managementList",
          hideInBread: true,
          id: 521
        },
        component: () => import("@/view/managementSetting/index.vue")
      },
      {
        path: "edit",
        name: "adminEdit",
        meta: {
          title: "添加管理员账户",
          nameText: "router.index.addAdmin",
          sideMenuItemHidden: true,
          id: 521
        },
        component: () => import("@/view/managementSetting/editManagement.vue")
      }
    ]
  },
  // 活动管理
  {
    path: "/event-management",
    name: "event-management",
    component: Main,
    meta: {
      title: "活动管理",
      nameText: "router.index.eventManagement",
      id: 661
    },
    redirect: "/event-management/list",
    children: [
      {
        path: "list",
        name: "eventManagement",
        meta: {
          title: "活动管理",
          nameText: "router.index.eventManagement",
          id: 1921
        },
        component: () => import("@/view/eventManagement/index.vue")
      },
      {
        path: "weekStar",
        name: "weekStar",
        meta: {
          title: "周星活动",
          nameText: "router.index.weekStar",
          id: 1931
        },
        component: () => import("@/view/weekStar/index.vue")
      },
      {
        path: "groupFight",
        name: "groupFight",
        meta: {
          title: "群组对战",
          nameText: "router.index.groupFight",
          id: 2131
        },
        component: () => import("@/view/groupFightManagement/index.vue")
      },
      {
        path: "fight_detail",
        name: "fight_detail",
        meta: {
          title: "对战详情",
          nameText: "router.index.fightDetail",
          sideMenuItemHidden: true,
          id: 2131
        },
        component: () => import("@/view/groupFightManagement/fightList.vue")
      },
      {
        path: "fruitsBigwig",
        name: "fruitsBigwig",
        meta: {
          title: "水果大亨",
          nameText: "router.index.fruitsBigwig",
          id: 2321
        },
        component: () => import("@/view/fruitsBigwig/index.vue")
      },
      {
        path: "activityDeploy",
        name: "activityDeploy",
        meta: {
          title: "活动配置",
          nameText: "router.index.activityDeploy",
          id: 2472
        },
        component: () => import("@/view/activityDeploy/index.vue")
      },
      {
        // /:teamId
        path: "taskDeploy/:code/:id/:teamId",
        name: "taskDeploy",
        meta: {
          title: "任务配置",
          nameText: "router.index.taskDeploy",
          hideInBread: true,
          sideMenuItemHidden: true,
          id: 2472
        },
        component: () => import("@/view/activityDeploy/taskIndex.vue")
      },
      {
        // /:现金赛 128 进 32
        path: "playerRoll/:code/:id/:scheduleId",
        name: "playerRoll",
        meta: {
          title: "选手名单",
          nameText: "router.index.playerRoll",
          hideInBread: true,
          sideMenuItemHidden: true,
          id: 2472
        },
        component: () => import("@/view/activityDeploy/playerIndex.vue")
      },
      {
        // /:现金赛 n 进 n
        path: "playerRoll2/:code/:id/:scheduleId",
        name: "playerRoll2",
        meta: {
          title: "选手名单",
          nameText: "router.index.playerRoll",
          hideInBread: true,
          sideMenuItemHidden: true,
          id: 2472
        },
        component: () => import("@/view/activityDeploy/playerIndex2.vue")
      },
      {
        // /:国管名单
        path: "stateRoll/:code/:id",
        name: "stateRoll",
        meta: {
          title: "选手名单",
          nameText: "router.index.stateRoll",
          hideInBread: true,
          sideMenuItemHidden: true,
          id: 2472
        },
        component: () => import("@/view/activityDeploy/stateIndex.vue")
      },
      {
        path: "actBlacklist",
        name: "actBlacklist",
        meta: {
          title: "活动黑名单",
          nameText: "router.index.actBlacklist",
          id: 2472
        },
        component: () => import("@/view/actBlacklist/index.vue")
      },
      {
        path: "actExcess",
        name: "actExcess",
        meta: {
          title: "活动补票",
          nameText: "router.index.actExcess",
          id: 3512
        },
        component: () => import("@/view/activityDeploy/actExcess.vue")
      }
    ]
  },
  // 道具管理
  {
    path: "/items-management",
    name: "items-management",
    component: Main,
    meta: {
      title: "道具管理",
      nameText: "router.index.mouldManagement",
      id: 1161
    },
    children: [
      {
        path: "itemsManagement",
        name: "itemsManagement",
        meta: {
          title: "座驾管理",
          nameText: "router.index.itemsManagement",
          id: 731
        },
        component: () => import("@/view/itemsManagement/index.vue")
      },
      {
        path: "expressionList",
        name: "expressionList",
        component: () => import("@/view/expressionManagement/index.vue"),
        meta: {
          title: "表情管理",
          nameText: "router.index.expressionManagement",
          id: 1011
        }
      },
      {
        path: "themeManager",
        name: "themeManager",
        component: () => import("@/view/themeManager/index.vue"),
        meta: {
          title: "主题管理",
          nameText: "router.index.themeManager",
          id: 1271
        }
      },
      {
        path: "tireManagement",
        name: "tireManagement",
        component: () => import("@/view/tireManagement/index.vue"),
        meta: {
          title: "头饰管理",
          nameText: "router.index.tireManagement",
          id: 1091
        }
      },
      {
        path: "orderManagement",
        name: "orderManagement",
        component: () => import("@/view/orderManagement/index.vue"),
        meta: {
          title: "勋章管理",
          nameText: "router.index.orderManagement",
          id: 1281
        }
      },
      {
        path: "nameplateManagement",
        name: "nameplateManagement",
        component: () => import("@/view/nameplateManagement/index.vue"),
        meta: {
          title: "铭牌管理",
          nameText: "router.index.nameplateManagement",
          id: 1281
        }
      },
      {
        path: "nameplate-user-list",
        name: "nameplate-user-list",
        meta: {
          title: "铭牌管理用户列表",
          nameText: "router.index.itemsUserList",
          sideMenuItemHidden: true,
          id: 731
        },
        component: () => import("@/view/nameplateManagement/userList.vue")
      },
      // 头饰管理用户列表
      {
        path: "tire-user-list",
        name: "tire-user-list",
        meta: {
          title: "头饰管理用户列表",
          nameText: "router.index.itemsUserList",
          sideMenuItemHidden: true,
          id: 731
        },
        component: () => import("@/view/tireManagement/userList.vue")
      },
      {
        path: "order-user-list",
        name: "order-user-list",
        meta: {
          title: "勋章管理用户列表",
          nameText: "router.index.itemsUserList",
          sideMenuItemHidden: true,
          id: 731
        },
        component: () => import("@/view/orderManagement/userList.vue")
      },
      {
        path: "items-user-list",
        name: "items-user-list",
        meta: {
          title: "座驾管理用户列表",
          nameText: "router.index.itemsUserList",
          sideMenuItemHidden: true,
          id: 731
        },
        component: () => import("@/view/itemsManagement/userList.vue")
      }
    ]
  },
  // 系统消息
  {
    path: "/system-information",
    name: "system-information",
    component: Main,
    meta: {
      title: "消息通知",
      nameText: "router.index.InfoInform",
      id: 2465
    },
    redirect: "/system-information/list",
    children: [
      {
        path: "list",
        name: "systemInformation",
        meta: {
          title: "系统消息",
          nameText: "router.index.systemInformation",
          id: 801
        },
        component: () => import("@/view/systemInformation/index.vue")
      },
      {
        path: "groupInfo",
        name: "groupInfo",
        meta: {
          title: "群发消息",
          nameText: "router.index.groupInformation",
          id: 2466
        },
        component: () => import("@/view/systemInformation/groupInfo.vue")
      }
    ]
  },
  // 广告管理
  {
    path: "/banner-information",
    name: "banner-information",
    component: Main,
    meta: {
      title: "广告管理",
      nameText: "router.index.bannerMsg",
      id: 1611
    },
    redirect: "/banner-information/list",
    children: [
      {
        path: "list",
        name: "adManagement",
        meta: {
          title: "匹配Banner",
          nameText: "router.index.adManagement",
          id: 691
        },
        component: () => import("@/view/adManagement/index.vue")
      },
      {
        path: "hot",
        name: "bannerInformation",
        meta: {
          title: "热门Banner",
          nameText: "router.index.bannerInformation",
          id: 841
        },
        component: () => import("@/view/bannerInformation/index.vue")
      },
      {
        path: "groupBanner",
        name: "groupBanner",
        meta: {
          title: "群组Banner",
          nameText: "router.index.groupBanner",
          id: 1621
        },
        component: () =>
          import("@/view/bannerInformation/groupBanner/index.vue")
      },
      {
        path: "foundBanner",
        name: "foundBanner",
        meta: {
          title: "发现Banner",
          nameText: "router.index.foundBanner",
          id: 1631
        },
        component: () =>
          import("@/view/bannerInformation/foundBanner/index.vue")
      },
      {
        path: "agentBanner",
        name: "agentBanner",
        meta: {
          title: "代理Banner",
          nameText: "router.index.agentBanner",
          id: 3101
        },
        component: () =>
          import("@/view/bannerInformation/agentBanner/index.vue")
      },
      {
        path: "gameBanner",
        name: "gameBanner",
        meta: {
          title: "游戏中心Banner",
          nameText: "router.index.gameBanner",
          id: 3489
        },
        component: () => import("@/view/bannerInformation/gameBanner/index.vue")
      },
      {
        path: "flashScreen",
        name: "flashScreen",
        meta: {
          title: "闪屏",
          nameText: "router.index.flashScreen",
          id: 1991
        },
        component: () =>
          import("@/view/bannerInformation/flashScreen/index.vue")
      },
      {
        path: "operationPopup",
        name: "operationPopup",
        meta: {
          title: "运营弹窗",
          nameText: "router.index.operationPopup",
          id: 2001
        },
        component: () =>
          import("@/view/bannerInformation/operationPopup/index.vue")
      }
    ]
  },
  // 新用户邀请审核
  {
    path: "/newUserAudit",
    name: "newUserAudit",
    component: Main,
    meta: {
      title: "新用户奖励审核",
      nameText: "router.index.newUserAudit",
      id: 2421
    },
    redirect: "/newUserAudit/index",
    children: [
      {
        path: "index",
        name: "new-userAudit",
        meta: {
          title: "新用户奖励审核",
          nameText: "router.index.newUserAudit",
          id: 2421
        },
        component: () => import("@/view/newUserAudit/index.vue")
      },
      {
        path: "detailList",
        name: "detailList",
        meta: {
          title: "查看详情",
          nameText: "router.index.detailList",
          sideMenuItemHidden: true
        },
        component: () => import("@/view/newUserAudit/detailList.vue")
      }
    ]
  },
  // 群组活动奖励审核
  {
    path: "/group-audit",
    name: "group-audit",
    component: Main,
    meta: {
      title: "群组活动奖励审核",
      nameText: "router.index.groupAudit",
      id: 2469
    },
    redirect: "/groupAudit/list",
    children: [
      {
        path: "groupAudit",
        name: "groupAudit",
        meta: {
          title: "群组活动奖励审核",
          nameText: "router.index.groupAudit",
          hideInBread: true,
          id: 2469
        },
        component: () => import("@/view/groupAudit/index.vue")
      }
    ]
  },
  // 金币数据统计
  {
    path: "/coin-statistics",
    name: "coin-statistics",
    component: Main,
    meta: {
      title: "金币数据统计",
      nameText: "router.index.coinStatistics",
      id: 3461
    },
    redirect: "/coinStatistics/list",
    children: [
      {
        path: "coinStatistics",
        name: "coinStatistics",
        meta: {
          title: "金币数据统计",
          nameText: "router.index.coinStatistics",
          hideInBread: true,
          id: 3461
        },
        component: () => import("@/view/coinStatistics/index.vue")
      }
    ]
  },
  // 充值代理管理
  {
    path: "/topUpAgent",
    name: "topUpAgent",
    component: Main,
    meta: {
      title: "充值代理管理",
      nameText: "router.index.topUpAgent",
      id: 1761
    },
    redirect: "/topUpAgent/list",
    children: [
      {
        path: "list",
        name: "rechargeAgent",
        meta: {
          title: "信息管理",
          nameText: "router.index.rechargeAgent",
          id: 1761
        },
        component: () => import("@/view/topUpAgent/index.vue")
      },
      {
        path: "particularsList",
        name: "particularsList",
        meta: {
          title: "销售明细列表",
          nameText: "router.index.itemsParticularsList",
          sideMenuItemHidden: true,
          id: 1761
        },
        component: () => import("@/view/topUpAgent/particularsList.vue")
      },
      {
        path: "particularsListF",
        name: "particularsListF",
        meta: {
          title: "销售明细列表",
          nameText: "router.index.itemsParticularsList",
          sideMenuItemHidden: true,
          id: 1761
        },
        component: () => import("@/view/topUpAgent/particularsListF.vue")
      },
      {
        path: "vepAgentView",
        name: "vepAgentView",
        meta: {
          title: "二级代理信息管理",
          nameText: "router.index.vepAgentRouter",
          sideMenuItemHidden: true,
          id: 1761
        },
        component: () => import("@/view/topUpAgent/vepAgentView.vue")
      },
      {
        path: "distributionList",
        name: "distributionList",
        meta: {
          title: "分销明细",
          nameText: "router.index.distribution",
          sideMenuItemHidden: true,
          id: 1761
        },
        component: () => import("@/view/topUpAgent/distributionList.vue")
      }
    ]
  },
  // 正式服不更新（删除用户信息管理）
  {
    path: "/del-user",
    name: "del-user",
    component: Main,
    meta: {
      title: "删除用户信息管理",
      nameText: "router.index.delUserInfomation",
      id: 901
    },
    redirect: "/del-user/userInformation",
    children: [
      {
        path: "userInformation",
        name: "del-userInformation",
        component: () => import("@/view/del-userInformation/index.vue"),
        meta: {
          title: "删除用户信息管理",
          nameText: "router.index.delUserInfomation",
          hideInBread: true, // 模块的首页
          id: 901
        }
      }
    ]
  },
  // 批量发放管理
  {
    path: "/diamondIssue",
    name: "diamondIssue",
    component: Main,
    meta: {
      title: "批量发放管理",
      nameText: "router.index.batchIssue",
      id: 2651
    },
    redirect: "/diamondIssue/page",
    children: [
      {
        path: "sendCoinsList",
        name: "diamondIssue-sendCoinsList",
        meta: {
          title: "钻石发放管理",
          nameText: "router.index.diamondIssue",
          id: 1441
        },
        component: () => import("@/view/diamondIssue/sendCoinsList.vue")
      },
      {
        path: "sendNobilityList",
        name: "nobilityIssue-sendNobilityList",
        meta: {
          title: "贵族发放管理",
          nameText: "router.index.nobilityIssue",
          id: 2652
        },
        component: () => import("@/view/diamondIssue/sendNobilityList.vue")
      },
      {
        path: "stagePropertyList",
        name: "stage-property",
        meta: {
          title: "道具发放管理",
          nameText: "router.index.stageProperty",
          id: 2981
        },
        component: () => import("@/view/diamondIssue/stagePropertyList.vue")
      },
      {
        path: "sendGameMoney",
        name: "send-GameMoney",
        meta: {
          title: "游戏币发放管理",
          nameText: "router.index.sendGameMoney",
          id: 3437
        },
        component: () => import("@/view/diamondIssue/sendGameMoney.vue")
      }
    ]
  },
  //群组扶持
  {
    path: "/groupSupport",
    name: "groupSupport",
    component: Main,
    meta: {
      title: "群组扶持",
      nameText: "router.index.groupSupport",
      id: 1401
    },
    redirect: "/groupSupport/page",
    children: [
      {
        path: "page",
        name: "groupSupport-page",
        component: () => import("@/view/groupSupport/index.vue"),
        meta: {
          title: "群组扶持",
          nameText: "router.index.groupSupport",
          // hideInBread: true,
          id: 1401
        }
      }
    ]
  },
  // 女孩扶持
  {
    path: "/girlSupport",
    name: "girlSupport",
    component: Main,
    meta: {
      title: "女孩扶持",
      nameText: "router.index.girlSupport",
      id: 1471
    },
    redirect: "/girlSupport/page",
    children: [
      {
        path: "page",
        name: "girlSupport-page",
        component: () => import("@/view/girlSupport/index.vue"),
        meta: {
          title: "女孩扶持",
          nameText: "router.index.girlSupport",
          id: 3051
        }
      }
    ]
  },
  //家族管理
  {
    path: "/nationalPower",
    name: "nationalPower",
    component: Main,
    meta: {
      title: "家族管理",
      nameText: "router.index.nationalPower",
      id: 1471
    },
    redirect: "/nationalPower/page",
    children: [
      {
        path: "page",
        name: "nationalPower-page",
        component: () => import("@/view/nationalPower/index.vue"),
        meta: {
          title: "家族管理",
          nameText: "router.index.nationalPower",
          // hideInBread: true,
          id: 1471
        }
      }
    ]
  },
  // 玩法管理
  {
    path: "/playing-management",
    name: "playing-management",
    component: Main,
    meta: {
      title: "玩法管理",
      nameText: "router.index.playingManagement",
      id: 1841
    },
    redirect: "/playing-Management/list",
    children: [
      {
        path: "list",
        name: "luckyBox",
        meta: {
          title: "幸运盒子",
          nameText: "router.index.luckyBox",
          id: 1961
        },
        component: () => import("@/view/playingManagement/index.vue")
      },
      {
        path: "h5luckyBox",
        name: "h5luckyBox",
        meta: {
          title: "H5幸运盒子",
          nameText: "router.index.h5luckyBox",
          id: 3470
        },
        component: () => import("@/view/h5luckyBox/index.vue")
      },
      {
        path: "fruits-management",
        name: "fruits-management",
        meta: {
          title: "水果机",
          nameText: "router.index.fruits",
          id: 2231
        },
        component: () => import("@/view/fruitsManagement/index.vue")
      },
      {
        path: "slot-game",
        name: "slot-game",
        meta: {
          title: "slot榜单",
          nameText: "router.index.slotName",
          id: 3011
        },
        component: () => import("@/view/slotGame/index.vue")
      },
      {
        path: "candy-game",
        name: "candy-game",
        meta: {
          title: "candy榜单",
          nameText: "router.index.candyName",
          id: 3071
        },
        component: () => import("@/view/candyGame/index.vue")
      },
      {
        path: "greedy-game",
        name: "greedy-game",
        meta: {
          title: "greedy榜单",
          nameText: "router.index.greedyName",
          id: 3191
        },
        component: () => import("@/view/greedyGame/index.vue")
      },
      {
        path: "game-slot",
        name: "game-slot",
        meta: {
          title: "多财多福",
          nameText: "router.index.gameSlotName",
          id: 3231
        },
        component: () => import("@/view/gameSlot/index.vue")
      },
      {
        path: "game-racing",
        name: "game-racing",
        meta: {
          title: "赛车游戏",
          nameText: "router.index.gameRacingName",
          id: 3261
        },
        component: () => import("@/view/gameRacing/index.vue")
      },
      {
        path: "game-egypt",
        name: "game-egypt",
        meta: {
          title: "埃及slot",
          nameText: "router.index.egyptSlotName",
          id: 3341
        },
        component: () => import("@/view/gameEgypt/index.vue")
      },
      {
        path: "game-fish",
        name: "game-fish",
        meta: {
          title: "捕鱼游戏",
          nameText: "router.index.fishingGameName",
          id: 3371
        },
        component: () => import("@/view/gameFish/index.vue")
      },
      {
        path: "game-football",
        name: "game-football",
        meta: {
          title: "足球slot",
          nameText: "router.index.footballName",
          id: 3457
        },
        component: () => import("@/view/gameFootball/index.vue")
      },
      {
        path: "game-sorceress",
        name: "game-sorceress",
        meta: {
          title: "女巫slot",
          nameText: "router.index.sorceressSlotName",
          id: 3341
        },
        component: () => import("@/view/gameSorceress/index.vue")
      },
      {
        path: "game-party",
        name: "game-party",
        meta: {
          title: "Teenparty",
          nameText: "router.index.teenpartyName",
          id: 3341
        },
        component: () => import("@/view/gameParty/index.vue")
      },
      {
        path: "game-foodie",
        name: "game-foodie",
        meta: {
          title: "foodie游戏",
          nameText: "router.index.foodie",
          id: 3518
        },
        component: () => import("@/view/foodieManagement/index.vue")
      }
      ////////////////////////////////////
    ]
  },
  // 批量IP查询
  {
    path: "/batch-ip",
    name: "batch-ip",
    component: Main,
    meta: {
      title: "批量IP查询",
      nameText: "router.index.batchIP",
      id: 1971
    },
    redirect: "/batchIP/list",
    children: [
      {
        path: "batchIP",
        name: "batchIP",
        meta: {
          title: "批量IP查询",
          nameText: "router.index.batchIP",
          hideInBread: true,
          id: 1971
        },
        component: () => import("@/view/batchIP/index.vue")
      }
    ]
  },
  // 风险管理
  {
    path: "/risk-management",
    name: "risk-management",
    component: Main,
    meta: {
      title: "风险管理",
      nameText: "router.index.riskManagement",
      id: 2341
    },
    redirect: "/riskManagement/list",
    children: [
      {
        path: "riskManagement",
        name: "riskManagement",
        meta: {
          title: "风险管理",
          nameText: "router.index.riskManagement",
          hideInBread: true,
          id: 2341
        },
        component: () => import("@/view/riskManagement/index.vue")
      }
    ]
  },
  // 设置
  {
    path: "/setting",
    name: "setting",
    component: Main,
    meta: {
      title: "设置",
      nameText: "router.index.setting",
      id: 2891
    },
    redirect: "/setting/index",
    children: [
      {
        path: "index",
        name: "index",
        component: () => import("@/view/setting/index.vue"),
        meta: {
          title: "版本号设置",
          nameText: "router.index.versionNumberSetting",
          id: 2891
        }
      }
    ]
  },
  // 获取token
  {
    path: "/get-token",
    name: "get-token",
    component: Main,
    meta: {
      title: "TOKEN",
      nameText: "router.index.getToken",
      id: 3311
    },
    redirect: "/getToken/list",
    children: [
      {
        path: "getToken",
        name: "getToken",
        meta: {
          title: "TOKEN",
          nameText: "router.index.getToken",
          hideInBread: true,
          id: 3311
        },
        component: () => import("@/view/getToken/index.vue")
      }
    ]
  },
  // 统计图
  // {
  //   path: "/get-chart",
  //   name: "get-chart",
  //   component: Main,
  //   meta: {
  //     title: "CHART",
  //     nameText: "router.index.getChart",
  //     id: 3311
  //   },
  //   redirect: "/getChart/list",
  //   children: [
  //     {
  //       path: "getChart",
  //       name: "getChart",
  //       meta: {
  //         title: "CHART",
  //         nameText: "router.index.getCac",
  //         hideInBread: true,
  //         id: 3311
  //       },
  //       component: () => import("@/view/getChart/index.vue")
  //     },
  //     {
  //       path: "getActive",
  //       name: "getActive",
  //       meta: {
  //         title: "CHART",
  //         nameText: "router.index.getActive",
  //         hideInBread: true,
  //         id: 3311
  //       },
  //       component: () => import("@/view/getChart/activeIndex.vue")
  //     }
  //   ]
  // },
  // 401页面
  {
    path: "/401",
    name: "error_401",
    meta: {
      hideInMenu: true,
      nameText: "router.index.error401"
    },
    component: () => import("@/view/error-page/401.vue")
  },
  // 500页面
  {
    path: "/500",
    name: "error_500",
    meta: {
      hideInMenu: true,
      nameText: "router.index.error500"
    },
    component: () => import("@/view/error-page/500.vue")
  },
  // 404页面
  {
    path: "*",
    name: "error_404",
    meta: {
      hideInMenu: true,
      nameText: "router.index.error404"
    },
    component: () => import("@/view/error-page/404.vue")
  }
  // 路由模板
  // {
  //   path: "",
  //   name: "",
  //   component: Main,
  //   meta: {},
  //   redirect: "",
  //   children: [
  //     {
  //       path: "",
  //       name: "",
  //       component: () => import(""),
  //       meta: {
  //         title: "",
  //         nameText: "",
  //         id: 2341
  //       }
  //     }
  //   ]
  // },
];



// WEBPACK FOOTER //
// ./src/router/routers.js